import React from 'react';
import { useViewport } from '~/utils/viewport-provider';

enum Theme {
  Compact = 'compact',
  Relaxed = 'relaxed',
}
interface BlockItem {
  price_value: number;
  price: string;
  performance_value: number;
  performance: string;
  price_width?: number;
  performance_width?: number;
  title: string;
}

interface Block {
  _template: string;
  css_class_name: string;
  left: {
    title: string;
    subtitle: string;
  };
  right: {
    title: string;
    subtitle: string;
  };
  items: BlockItem[];
  text: string;
  theme: Theme;
}

const PricingPerformanceComparison = ({ block }: { block: Block }) => {
  const { isDesktop } = useViewport();

  let maxPrice = 0;
  let maxPerformance = 0;

  const { theme = Theme.Relaxed } = block;

  // get max values
  block.items.map(
    (item: {
      price_value: number;
      price: string;
      performance_value: number;
      performance: string;
    }) => {
      item.price_value = Number(item.price.replace(/[^\d\.]*/g, ''));
      if (item.price_value > maxPrice) {
        maxPrice = item.price_value;
      }
      item.performance_value = Number(
        item.performance.replace(/[^\d\.]*/g, '')
      );
      if (item.performance_value > maxPerformance) {
        maxPerformance = Math.ceil(item.performance_value / 10) * 10;
      }
      return null;
    }
  );

  // calculate percentages
  block.items.map(item => {
    item.price_width = (item.price_value * 100) / maxPrice;
    item.performance_width = (item.performance_value * 100) / maxPerformance;
    return null;
  });

  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div className='container'>
        <div
          className={`row ${theme === Theme.Compact ? 'items-end justify-center' : ''}`}
        >
          <div
            className={`pp-col ${theme === Theme.Compact ? 'col-12 col-lg-auto' : 'col-lg-6'}`}
          >
            <div
              className={`content-wr left ${theme} ${theme === Theme.Compact ? '!rounded-[20px] !p-[30px]' : ''}`}
            >
              <h3
                dangerouslySetInnerHTML={{
                  __html: block.left.title,
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: block.left.subtitle,
                }}
              />
              <div className={`compare ${theme}`}>
                {block.items.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className='item'
                    >
                      <div className='content'>
                        <h4
                          dangerouslySetInnerHTML={{
                            __html: item.title,
                          }}
                        />
                        <span
                          className='value'
                          dangerouslySetInnerHTML={{
                            __html: item.price,
                          }}
                        />
                      </div>
                      <div className='line'>
                        <span style={{ width: `${item.price_width}%` }}></span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div
            className={`${theme === Theme.Compact ? 'col-12 col-lg-auto' : 'col-lg-6'}`}
          >
            <div
              className={`content-wr right ${theme} ${theme === Theme.Compact ? '!rounded-[20px]' : ''}`}
            >
              <h3
                dangerouslySetInnerHTML={{
                  __html: block.right.title,
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: block.right.subtitle,
                }}
              />
              <div
                className={`compare ${theme} ${theme === Theme.Compact ? 'w-full' : ''}`}
              >
                {block.items.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className='item'
                    >
                      <div className='content'>
                        <h4
                          dangerouslySetInnerHTML={{
                            __html: item.title,
                          }}
                        />
                        <span
                          className='value'
                          dangerouslySetInnerHTML={{
                            __html: item.performance,
                          }}
                        />
                      </div>
                      <div className='line'>
                        <span
                          style={{ width: `${item.performance_width}%` }}
                        ></span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div
          className='text-formatted'
          dangerouslySetInnerHTML={{ __html: block.text }}
        ></div>
      </div>
    </section>
  );
};

export default PricingPerformanceComparison;
